const Input = (() => {
  const config = {
    get triggers() {
      return this.triggerCN
        .map(CN => [...document.querySelectorAll(`.${CN}`)])
        .reduce((acc, current) => [...acc, ...current]);
    },
    outline: 'div.input__outline',
    triggerCN: ['input'],
    notchCN: 'input__outline--notched',
  };

  const handleInputNotch = ({ e }) => {
    const target = e.srcElement;

    if (target.value.length === 0) {
      target.parentNode
        .querySelector(config.outline)
        .classList.remove(config.notchCN);
    } else {
      target.parentNode
        .querySelector(config.outline)
        .classList.add(config.notchCN);
    }
  };

  const build = () => {
    config.triggers.forEach(trigger => {
      trigger.addEventListener('input', e => {
        handleInputNotch({ e });
      });
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export const queueInput = () =>
  setTimeout(() => {
    Input.init();
  }, 100);

export default Input.init();
